import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';
import IdeointiMob from './IdeointiMob.js';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';



let stopupdates = function () {};

function Ideointi(p)
{
	React.useEffect( () => { if ( window.RECENTLOAD )  window.drawIdeointi() });
	let [progress, pupdate] = React.useState(0);
	let [progressLp, pupdateLp] = React.useState(0);
	let [nomoreload, nomoreupdate] = React.useState(<div></div>);

	stopupdates = nomoreupdate;

	if (! window.KAIKKIIDEOINTIKUVATLADATTU )
	{
		function loopy()
		{
				if (! window.KAIKKIIDEOINTIKUVATLADATTU )
				{
					setTimeout(loopy, 500);
				}
				else
				{
					let empty = [];
					stopupdates(empty);
				}
				pupdate((window.allmedia.ideointi.length) + " images out of " + window.allmedia.ideointis);
				pupdateLp(100 * (window.allmedia.ideointi.length/window.allmedia.ideointis));
		}
		setTimeout(loopy, 1000);
		return(	<ThemeProvider theme={window.MUIthemeWhite}>
			<div className="keskitetty" style={{color: "#000000", fontSize: "125%"}}>
				<div>Ladataan:</div>
				<div>
    	  				<LinearProgress variant="determinate" value={progressLp} />{nomoreload}
				</div>
			</div></ThemeProvider>);
	}
	else
	{
		if (isMobile && window.NOTIPAD)
		{
			return (<IdeointiMob />);
		}
		else
		{
			return (<div style={{color: "#000000", fontSize: "125%"}}>
			<div key="ideointiosioeka" className="kuvallinenoikea">
				<div>
					<img height="500vh" src={window.IDEOINTITEKSTIT.ekaosiokuva} />
				</div>
				<div>
					<h1>{window.IDEOINTITEKSTIT.ekaosio}</h1>
					<div key="gapihmomia" className="otsikkogap"></div>
					{window.IDEOINTITEKSTIT.ekaosioekar}
					<div key="gapihmomib" className="paragap"></div>
					{window.IDEOINTITEKSTIT.ekaosiotokar}
				</div>
			</div>
			<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
			<div key="gapihmomic" className="osiogap"></div>
			<div key="ideointiosiotoka" className="kuvallinenvasenkapea">
				<div style={{width: "80%", display: "flex", alignItems: "center"}}>
					<span style={{verticalAlign: "middle"}} >{window.IDEOINTITEKSTIT.tokaosioekar}</span>
				</div>
				<div>
					<img height="250vh" src={window.IDEOINTITEKSTIT.tokaosiokuva} />
				</div>
			</div>
			<BlobLeft fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" height="150vh"/>
			<div key="gapihmomid" className="osiogap"></div>
			<div className="vasenlevea">
				<h3>{window.IDEOINTITEKSTIT.kolmasosioekar}</h3>
			</div>
			<div key="gapihmomie" className="osiogap"></div>
			<div key="gapihmomif" className="osiogap"></div>
			<div key="ideointineljasosio" className="kuvallinenoikeavasmargi">
				<div>
					<img height="300vh" src={window.IDEOINTITEKSTIT.neljasosiokuva} />
				</div>
				<div></div>
				<div>
					{window.IDEOINTITEKSTIT.neljasosioekar}
					<div key="gapihmomih" className="paragap"></div>
					<h3>{window.IDEOINTITEKSTIT.neljasosiotokar}</h3>
				</div>
			</div>
			<div key="gapihmomii" className="osiogap"></div>
			<div key="gapihmomiq" className="osiogap"></div>
			<div className="vasen">
					{window.IDEOINTITEKSTIT.kuudesosioekar}
					<div key="gapihmomiaa" className="otsikkogap"></div>
					{window.IDEOINTITEKSTIT.kuudesosiotokar}
					<div key="gapihmomiab" className="otsikkogap"></div>
			</div>
			<div key="gapihmomipq" className="osiogap"></div>
			<div className="seuraavasivu">
				<div className="seuraavasivuotsikko" >
					<Link to="../jalostus" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToJalostus}>
						<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>JALOSTUS</span>
					</Link>
				</div>
				<div style={{transform: "scale(0.75)"}}>
					<Link to="../jalostus" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToJalostus}>

						<ArrowRight stroke="#000000"/>
					</Link>
				</div>
			</div>

			</div>);
		}
	}
}

function moveToJalostus()
{
	window.SETJALOSTUS();
	window.drawJalostus();
}




export default Ideointi;
